"use strict";

exports.__esModule = true;
exports.isInIFrame = void 0;
var isInIFrame = exports.isInIFrame = function isInIFrame() {
  return window.self !== window.top;
};